import React from 'react';
import classnames from 'classnames';
import Theme from "./Theme.js";
import S from './Portal.css';

/**
 * Defines the a React Portal location. The PortalOverlay or React.createPortal can be used to
 * put React components in the div create by the Portal
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default class Portal extends React.Component {
  render() {
    // eslint-disable-next-line no-unused-vars
    const {
      id = 'portal',
      className,
      layoutOptions,
      ...rest
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: classnames(className, S.portal),
      id: id,
      ...rest
    });
  }
}